// countries.js

import { roundsData } from "../../resources/constant-data/roundsData";

// Array of countries
export const countries = [
  { optionKey: "Bangalore", optionValue: "Bangalore" },
  { optionKey: "Gurugram", optionValue: "Gurugram" },
  { optionKey: "Chennai", optionValue: "Chennai" },
  { optionKey: "Kolkata", optionValue: "Kolkata" },
  // ... (add more countries as needed)
];

export const recOps = [
  { optionKey: "Human Resources", optionValue: "Human Resources" },
  { optionKey: "IT", optionValue: "IT" },
  { optionKey: "Finance", optionValue: "Finance" },
  { optionKey: "Customer Service", optionValue: "Customer Service" },
  // ... (add more countries as needed)
];
export const interviewerRounds = [
  {
    optionKey: roundsData.firstRound.name,
    optionValue: roundsData.firstRound.name,
  },
  {
    optionKey: roundsData.secondRound.name,
    optionValue: roundsData.secondRound.name,
  },
];

// Array of states in India
export const indianStates = [
  { optionKey: "Andhra Pradesh", optionValue: "Andhra Pradesh" },
  { optionKey: "Arunachal Pradesh", optionValue: "Arunachal Pradesh" },
  { optionKey: "Assam", optionValue: "Assam" },
  { optionKey: "Bihar", optionValue: "Bihar" },
  { optionKey: "Chhattisgarh", optionValue: "Chhattisgarh" },
  { optionKey: "Goa", optionValue: "Goa" },
  { optionKey: "Gujarat", optionValue: "Gujarat" },
  { optionKey: "Haryana", optionValue: "Haryana" },
  { optionKey: "Himachal Pradesh", optionValue: "Himachal Pradesh" },
  { optionKey: "Jharkhand", optionValue: "Jharkhand" },
  { optionKey: "Karnataka", optionValue: "Karnataka" },
  { optionKey: "Kerala", optionValue: "Kerala" },
  { optionKey: "Madhya Pradesh", optionValue: "Madhya Pradesh" },
  { optionKey: "Maharashtra", optionValue: "Maharashtra" },
  { optionKey: "Manipur", optionValue: "Manipur" },
  { optionKey: "Meghalaya", optionValue: "Meghalaya" },
  { optionKey: "Mizoram", optionValue: "Mizoram" },
  { optionKey: "Nagaland", optionValue: "Nagaland" },
  { optionKey: "Odisha", optionValue: "Odisha" },
  { optionKey: "Punjab", optionValue: "Punjab" },
  { optionKey: "Rajasthan", optionValue: "Rajasthan" },
  { optionKey: "Sikkim", optionValue: "Sikkim" },
  { optionKey: "Tamil Nadu", optionValue: "Tamil Nadu" },
  { optionKey: "Telangana", optionValue: "Telangana" },
  { optionKey: "Tripura", optionValue: "Tripura" },
  { optionKey: "Uttar Pradesh", optionValue: "Uttar Pradesh" },
  { optionKey: "Uttarakhand", optionValue: "Uttarakhand" },
  { optionKey: "West Bengal", optionValue: "West Bengal" },
  // ... (add more states as needed)
];

export const cities = [
  {
    optionKey: "Gurgaon",
    optionValue: "Gurgaon",
  },
  { optionKey: "Delhi", optionValue: "Delhi" },
  { optionKey: "Hyderabad", optionValue: "Hyderabad" },
  { optionKey: "Haridwar", optionValue: "Haridwar" },
];
